// src/utils/jobTitleNormalizer.js

/* ============================================
   CANONICAL JOB TITLE MAP
============================================ */
const TITLE_MAP = {
  /* ===============================
     C-SUITE
  =============================== */
  ceo: "CEO",
  "chief executive officer": "CEO",
  "chief exec officer": "CEO",
  "president & ceo": "CEO",
  "president and ceo": "CEO",
  "founder & ceo": "CEO",
  "co-founder & ceo": "CEO",

  cfo: "CFO",
  "chief financial officer": "CFO",
  "finance director": "CFO",

  coo: "COO",
  "chief operating officer": "COO",
  "operations director": "COO",

  cto: "CTO",
  "chief technology officer": "CTO",
  "head of technology": "CTO",

  cio: "CIO",
  "chief information officer": "CIO",

  cmo: "CMO",
  "chief marketing officer": "CMO",

  cro: "CRO",
  "chief revenue officer": "CRO",

  chro: "CHRO",
  "chief human resources officer": "CHRO",

  /* ===============================
     FOUNDERS
  =============================== */
  founder: "Founder",
  "co-founder": "Founder",
  "co founder": "Founder",
  "founder & president": "Founder",
  "founder and president": "Founder",

  /* ===============================
     PRESIDENT / OWNER
  =============================== */
  president: "President",
  owner: "Owner",
  "business owner": "Owner",
  proprietor: "Owner",
  partner: "Partner",
  "managing partner": "Partner",

  /* ===============================
     VICE PRESIDENT
  =============================== */
  vp: "Vice President",
  "v.p.": "Vice President",
  "vice president": "Vice President",
  "senior vice president": "Vice President",
  svp: "Vice President",
  "executive vice president": "Vice President",
  evp: "Vice President",

  /* ===============================
     DIRECTOR
  =============================== */
  director: "Director",
  "managing director": "Director",
  "executive director": "Director",
  "senior director": "Director",

  /* ===============================
     SALES / BUSINESS DEV
  =============================== */
  "sales manager": "Sales Manager",
  "business development manager": "Business Development",
  "business development director": "Business Development",
  "head of sales": "Sales Leader",
  "sales director": "Sales Leader",

  /* ===============================
     OPERATIONS
  =============================== */
  "operations manager": "Operations Manager",
  "plant manager": "Operations Manager",
  "general manager": "General Manager",

  /* ===============================
     ENGINEERING
  =============================== */
  engineer: "Engineer",
  "senior engineer": "Engineer",
  "software engineer": "Engineer",
  "mechanical engineer": "Engineer",

  /* ===============================
     HR
  =============================== */
  hr: "Human Resources",
  "human resources": "Human Resources",
  "hr manager": "Human Resources",
  "talent acquisition": "Human Resources",

  /* ===============================
     GOVERNMENT / ECON DEV
  =============================== */
  "economic development director": "Economic Development",
  "city manager": "City Manager",
  "county administrator": "County Administrator",
};

/* ============================================
   STRING NORMALIZATION
============================================ */
function normalizeString(str) {
  return str
    ?.toString()
    .toLowerCase()
    .trim()
    .replace(/\./g, "")
    .replace(/,/g, "")
    .replace(/&/g, "and")
    .replace(/\s+/g, " ");
}

/* ============================================
   MAIN NORMALIZER (DEFAULT EXPORT)
============================================ */
export default function normalizeJobTitle(rawTitle) {
  if (!rawTitle) return "";

  const normalized = normalizeString(rawTitle);

  // 1️⃣ Exact match first
  if (TITLE_MAP[normalized]) {
    return TITLE_MAP[normalized];
  }

  // 2️⃣ Partial match
  for (const key of Object.keys(TITLE_MAP)) {
    if (normalized.includes(key)) {
      return TITLE_MAP[key];
    }
  }

  // 3️⃣ Fallback (return cleaned original)
  return rawTitle.trim();
}
